var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c("div", { staticClass: "breadcrumb" }, [_vm._v("Modules")]),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        { attrs: { to: "/modules/new" } },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        { attrs: { to: _vm.editUrl, disabled: !_vm.canEdit } },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: !_vm.canDelete },
                          on: {
                            click: function ($event) {
                              return _vm.deleteModules()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "minus" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  items: _vm.modules,
                  columns: _vm.columns,
                  "selected-items": _vm.selected,
                },
                on: {
                  order: function ($event) {
                    return _vm.onOrder($event)
                  },
                  "item-clicked": function ($event) {
                    return _vm.edit($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }